import React from 'react';

const PrivacyPolicy = () => {
    // Şahıs Geliştirici Bilgileri: Kendi Adınız ve E-posta Adresinizle DOLDURUN
    const developerName = "Axiowar Geliştirme Ekibi"; 
    const contactEmail = "infoaxiowar@gmail.com"; 
    const lastUpdated = "12 Aralık 2025"; // Bugünün Tarihi

    return (
       <div className="p-6 md:p-12 lg:p-20 text-white bg-slate-900">
            <div className="max-w-5xl mx-auto bg-slate-800 p-8 rounded-lg shadow-2xl">
                <h1 className="text-4xl md:text-5xl font-extrabold mb-4 text-blue-400 border-b-2 border-blue-400 pb-3">
                    Axiowar Gizlilik Politikası
                </h1>
                <p className="text-sm mb-10 text-slate-400">
                    Son Güncelleme: {lastUpdated}
                </p>

                <p className="mb-6 text-slate-300">
                    Axiowar (Bireysel Geliştirici, {developerName} tarafından işletilmektedir) olarak, gizliliğinize büyük önem veriyoruz. Bu politika, hizmetlerimizi kullanırken bilgilerinizi nasıl topladığımızı, kullandığımızı ve koruduğumuzu açıklar.
                </p>

                <h2 className="text-2xl font-semibold mt-10 mb-4 text-blue-300">1. Topladığımız Bilgiler</h2>
                <p className="mb-4">Oyunumuzu kullandığınızda aşağıdaki bilgi türlerini toplayabiliriz:</p>
                
                <ul className="list-disc list-inside space-y-3 ml-4 text-slate-300">
                    <li>
                        <strong>Doğrudan Sağladığınız Bilgiler:</strong> Kayıt veya giriş sırasında sağladığınız e-posta adresi ve şifre (Firebase Authentication aracılığıyla güvenli bir şekilde saklanır). Oyuncu adı (Player Name), oyun istatistikleri (skorlar, galibiyetler, kayıplar vb.).
                    </li>
                    <li>
                        <strong>Otomatik Olarak Toplanan Bilgiler:</strong> IP adresi, tarayıcı tipi ve işletim sistemi (Oyun sadece masaüstü cihazlar için tasarlandığından, bu bilgi mobil erişimi kontrol etmek için kullanılır).
                    </li>
                    <li>
                        <strong>Çerezler (Cookies):</strong> Oturum yönetimi, tercihlerinizi hatırlama ve hizmetlerimizin işleyişi için tarayıcınızda küçük veri dosyaları kullanırız.
                    </li>
                </ul>

                <h2 className="text-2xl font-semibold mt-10 mb-4 text-blue-300">2. Bilgilerinizin Kullanımı</h2>
                <p className="mb-4 text-slate-300">Topladığımız bilgileri aşağıdaki amaçlarla kullanırız:</p>
                <ul className="list-disc list-inside space-y-3 ml-4 text-slate-300">
                    <li>Oyun hizmetini sunmak, sürdürmek ve geliştirmek (Hesap yönetimi, oyun oturumları).</li>
                    <li>Güvenlik sorunlarını tespit etmek ve önlemek.</li>
                    <li>Kullanıcı desteği sağlamak.</li>
                    <li>Yasal yükümlülüklerimizi yerine getirmek.</li>
                </ul>

                <h2 className="text-2xl font-semibold mt-10 mb-4 text-blue-300">3. Üçüncü Taraf Hizmetleri ve Reklamlar</h2>
                <p className="mb-4 text-slate-300">Hizmetlerimizi desteklemek ve reklam geliri elde etmek için üçüncü taraf hizmetleri kullanırız:</p>
                <ul className="list-disc list-inside space-y-3 ml-4 text-slate-300">
                    <li>
                        <strong>Firebase (Google):</strong> Kimlik doğrulama, veri tabanı (Firestore) ve hosting için kullanılır.
                    </li>
                    <li>
                        <strong>Reklam Ağları (Örn: Google AdSense):</strong> Reklamları sunmak için bu platformlar, ilgi alanlarınıza dayalı reklamlar göstermek amacıyla çerezler ve cihaz verileri toplayabilir. Bu platformların veri toplama ve kullanma uygulamaları kendi gizlilik politikaları kapsamındadır.
                    </li>
                </ul>

                <h2 className="text-2xl font-semibold mt-10 mb-4 text-blue-300">4. Bilgi Güvenliği</h2>
                <p className="text-slate-300">Bilgilerinizi yetkisiz erişime karşı korumak için makul güvenlik önlemleri alıyorum. Ancak internet üzerinden hiçbir aktarım %100 güvenli değildir.</p>

                <h2 className="text-2xl font-semibold mt-10 mb-4 text-blue-300">5. İletişim</h2>
                <p className="text-lg font-bold text-slate-300">
                    Bu Gizlilik Politikası ile ilgili herhangi bir sorunuz varsa, lütfen benimle iletişime geçin: 
                    <a href={`mailto:${contactEmail}`} className="text-blue-400 hover:text-blue-300 ml-2">
                        {contactEmail}
                    </a>
                </p>

            </div>
        </div>
    );
};

export default PrivacyPolicy;